import { Pipe, PipeTransform } from '@angular/core';
import { Chemical, ChemicalRevision } from '@context/shared/types/chemical';
import { DocumentReference, getDoc } from 'firebase/firestore';

@Pipe({
	name: 'chemicalLatestRevision',
	standalone: true,
})
export class ChemicalLatestRevisionPipe implements PipeTransform {
	transform(
		chemical: Chemical | null | undefined,
	): Promise<ChemicalRevision | null> {
		if (!chemical || !chemical.id || !chemical.latestRevision) {
			return Promise.resolve(null);
		}

		return getDoc(
			chemical.latestRevision as DocumentReference<ChemicalRevision>,
		).then((doc) => doc.data() as ChemicalRevision);
	}
}
